// Student schedule route (inside BodyView layout)
export default [
  {
    path: '/student-schedule',
    name: 'StudentSchedule',
    component: () => import("@/views/Page/Student/StudentSchedule.vue"),
    meta: {
      title: 'Student Schedule',
      requiresStudentAuth: true,
    },
  },
  {
    path: '/student-grades',
    name: 'StudentGrades',
    component: () => import("@/views/Page/Student/StudentGrades.vue"),
    meta: {
      title: 'Student Grades',
      requiresStudentAuth: true,
    },
  },
  /** طباعة السجل للطالب — مسار تحت /student/* يمر ببوابة الطالب بدون صلاحية AcadimecRecord */
  {
    path: '/student/academic-record-print',
    name: 'StudentAcademicRecordPrint',
    component: () => import("@/views/Page/Student/StudentAcademicRecordPrint.vue"),
    meta: {
      title: 'Academic Record Print',
      requiresStudentAuth: true,
    },
  },
];

